import { CeresFeaturesConfig } from './interfaces/ceres-features-config.interface';

const FEATURES: CeresFeaturesConfig = {
    timeManagement: {
        enabled: true,
        timeSheets: true,
        transactionalTimeTracking: true,
        capacity: true,
        absences: true,
        workload: true,
        disableTimeSheetsOption: false
    },
    businessPartner: {
        enabled: true
    },
    sales: {
        enabled: false,
        businessOpportunities: false,
        salesActivities: false,
        salesFunnel: false,
        offers: false,
        offersV2: false
    },
    projects: {
        enabled: true,
        copyExistingProject: true,
        copyExistingProjectWithChildren: false,
        orcChecker: false,
        inheritance: false,
        groups: {
            enabled: true,
            statusReports: false,
            classification: false
        },
        charging: true,
        timesheetLock: false,
        chargingCopyProposalBillingValue: false,
        nrsView: false,
        preStaffing: false,
        projectValueInheritance: false,
        restrictTimesheetFavoritesToAssignedProjects: false,
        projectSharedCosts: false
    },
    reporting: {
        enabled: true,
        dataQuality: false,
        pulseDashboard: false,
        costReport: false,
        workingHoursReport: true,
        absenceReport: true,
        gmsReportingDemo: false,
        productivityReport: false
    },
    employees: {
        enabled: true,
        experiences: true,
        multiRole: true
    },
    faq: {
        enabled: false
    },
    ticketTool: {
        enabled: true
    },
    administration: {
        enabled: true,
        servicePackages: true,
        departments: true,
        serviceProducts: true,
        orgIds: true,
        experiences: true,
        juno: false,
        customerPspElements: false,
        globalNotifications: false
    },
    services: {
        enabled: true,
        documents: true
    },
    scheduling: {
        enabled: true,
        scheduler: true,
        analytics: false,
        unrestrictedAccess: true
    },
    global: {
        currencyConversion: false,
        darkMode: true,
        sharepoint: false
    },
    sharepointExport: {
        enabled: false
    },
    pocReminder: {
        enabled: false
    },
    projectConfirmation: {
        enabled: false
    },
    documentCategorization: {
        enabled: true
    }
};

export default FEATURES;
